import { accessToken } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import Cookies from '~/utilities/BrowserCookies';
import getUserId from '~/utilities/getUserId';
import {
  applicationVersion,
  commonEnvironment,
  isProd
} from './constants/environment';

function log(status: 'imported' | 'initializing' | 'ready') {
  if (isProd) return;

  console.debug(`SRP DataDog is ${status}`, performance.now());
}

log('imported');

export default function initDataDog() {
  log('initializing');

  const isAuthUser = accessToken().isValidToken;

  datadogRum.init({
    applicationId: '12176191-bef0-4c22-ac4f-722c5fa109a6',
    clientToken: 'pubcedfeba7c3e48d9baa9fa8585f4404d3',
    site: 'datadoghq.com',
    service: 'serenity-ui',
    env: commonEnvironment,
    version: applicationVersion,
    sessionSampleRate: isAuthUser ? 100 : 10,
    sessionReplaySampleRate: isAuthUser ? 100 : 10,
    trackUserInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'allow',
    beforeSend: ({ view }) => {
      // assign all events to /cars for data cleanliness
      view.url = `${process.env.CVNA_APP_ABSOLUTE_BASE_URL}/cars`;
    }
  });

  datadogRum.onReady(() => {
    log('ready');
  });

  datadogRum.setUser({
    browserCookieId: Cookies.get('BrowserCookieId'),
    id: getUserId()
  });

  datadogRum.startSessionReplayRecording();
}
